import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { isLink } from '../utils';

@Injectable()
export class PostContentClickNavigationService {
  private readonly router = inject(Router);

  handleClick($event: Event, wysiwygRef: HTMLDivElement): void {
    const element = this.getLinkElement($event.target as HTMLElement, wysiwygRef);

    if (!element) {
      return;
    }

    if (element.origin === window.location.origin) {
      $event.preventDefault();

      this.router.navigateByUrl(element.pathname);
    }
  }

  private getLinkElement(
    element: HTMLElement | null,
    wysiwygRef: HTMLDivElement,
  ): HTMLAnchorElement | null {
    let selectedElement = element;
    while (selectedElement && !isLink(selectedElement) && wysiwygRef.contains(selectedElement)) {
      selectedElement = selectedElement.parentElement;
    }

    return isLink(selectedElement) ? selectedElement : null;
  }
}
